import React, { useEffect, useState } from 'react';
import { MainContainer } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { PerformanceMain, YearlyCard, TabBottomLine, TabWrapper, BorderBottom } from '../RecogntionAdmin/styles';
import { Table, ScrollableContainer } from '../common/commonStyles';
import { ImageUrl } from '../../utils/constants';
import { generateDummyData } from '../../utils/methods';

// Function to generate fresh random data
const generateRandomData = () => (
  [
    { month: 'January', members: generateDummyData(20) },
    { month: 'February', members: generateDummyData(20) },
    { month: 'March', members: generateDummyData(20) },
    { month: 'April', members: generateDummyData(20) },
    { month: 'May', members: generateDummyData(20) },
    { month: 'June', members: generateDummyData(20) },
    { month: 'July', members: generateDummyData(20) },
    { month: 'August', members: generateDummyData(20) },
    { month: 'September', members: generateDummyData(20) },
    { month: 'October', members: generateDummyData(20) },
    { month: 'November', members: generateDummyData(20) },
    { month: 'December', members: generateDummyData(20) },
  ]
);

const QuarterlyDummyData = [
  { month: 'January-March | Q1', members: generateDummyData(20) },
  { month: 'April-June | Q2', members: generateDummyData(20) },
  { month: 'July-September | Q3', members: generateDummyData(20) },
  { month: 'October-December | Q4', members: generateDummyData(20) }
];

const Performance = ({ selectedFilter }) => {
  const [showAll, setShowAll] = useState({});
  const [data, setData] = useState(generateRandomData());
  const [activeTab, setActiveTab] = useState(1);


  const tabChange = (value)=>{
    setActiveTab(value)
    setShowAll({})
  }  

  useEffect(() => {
    if(selectedFilter === "Quarterly"){
      setData(QuarterlyDummyData)
    }else{
      setData(generateRandomData)
    }
  },[selectedFilter])

  const handleShowMore = (month) => {
    setShowAll((prevState) => ({
      ...prevState,
      [month]: true,
    }));
  };

  const tabs = [
    { id: 1, label: 'Total Challenges' },
    { id: 2, label: 'Activity Challenges' },
    { id: 3, label: 'Wellness Challenges' },
    { id: 4, label: 'Steps' },
    { id: 5, label: 'Distance' },
    { id: 6, label: 'Workouts' }
  ];

  let getColor = "rgba(243, 122, 101, 1)";

  const renderCards = () => (
    <PerformanceMain isGap={selectedFilter === "Yearly" ? "32px" : selectedFilter === "Quarterly" ? "20px" : "24px"}>
      {selectedFilter === "Yearly" ? data.map((yearData) =>
        yearData.members.map((member, index) =>
          <div className='yearly' style={{ display: "block" }} key={index}>
            <YearlyCard>
              <div className='profile'>
                <img src={ImageUrl + "/" + member.image} alt={'no-image'} />
              </div>
              <div className='name'>{member?.name}</div>
              <div className='count'>{member?.count}</div>
              <div className='department'>{member?.department}</div>
              <div className='location'>{member?.location}</div>
            </YearlyCard>
          </div>)
      ) : data.map((monthData, index) => (
        <div className={selectedFilter === "Quarterly" ? 'quarterly' : 'month'} style={{ display: "block" }} key={index}>
          <Table padding="8px 0" insight>
            <div className="heading">{monthData.month}</div>
            <div className="type">
              <div className="name">Employees</div>
              <div className="value">{selectedFilter === "Quarterly"?"Total":"Total Challenges"}</div>
            </div>
            <ScrollableContainer
              height={showAll[monthData.month] ? "380px" : "330px"}
              showAllRows={showAll[monthData.month]}
            >
              {monthData.members
                .slice(0, showAll[monthData.month] ? monthData.members.length : 5)
                .map((data, memberIndex) => (
                  <div className="item" key={memberIndex}>
                    <div className="profile">
                      <img src={ImageUrl + "/" + data.image} alt={data.name} />
                    </div>
                    <div className="name">{data.name}</div>
                    <div className="value">{data.count}</div>
                  </div>
                ))}
            </ScrollableContainer>
            {monthData.members.length > 5 && !showAll[monthData.month] && (
              <div className="showmore">
                <div
                  className="button"
                  onClick={() => handleShowMore(monthData.month)}
                >
                  Show More
                </div>
              </div>
            )}
          </Table>
        </div>
      ))}
    </PerformanceMain>
  );

  return (
    <MainContainer margin>
      <TabWrapper>
        {tabs?.map((tab, index) => (
          <TabBottomLine
            key={index}
            active={activeTab === tab.id}
            background={getColor}
            onClick={() => tabChange(tab.id)}
          >
            {tab?.label}
            <BorderBottom active={activeTab === tab.id} background={getColor} />
          </TabBottomLine>
        ))}
      </TabWrapper>
      {renderCards()}
    </MainContainer>
  );
};

Performance.propTypes = {
  getColor: PropTypes.func.isRequired,
  selectedFilter: PropTypes.string
};

export default Performance;
